function numberOrText (x) {
  if (isNaN(x)) {
    return x;
  }
  return parseInt(x);
}

export default function postprocessStatisticsParams (compiledWidget, type) {

  // todo: WHY isArray + add more description

  // postprocess needed metrics
  if (compiledWidget[type].metrics && !Array.isArray(compiledWidget[type].metrics)) {
    let metricsList = compiledWidget[type].metrics.split(',').filter(i => i.length > 0);
    if (metricsList.length === 0) {
      metricsList = [];
    }

    compiledWidget[type].metrics = metricsList;
  }

  if (type === 'dsOrdersParams' && !Array.isArray(compiledWidget.dsOrdersParams.channels)) {
    let channelIds = compiledWidget[type].channels.split(',').
      filter(i => i.length > 0);
    if (channelIds.length === 0) {
      channelIds = [];
    }
    compiledWidget[type].channels = channelIds;
  }

  // postprocess channels filtration
  if (compiledWidget[type].channelIds) {
    if (!Array.isArray(compiledWidget[type].channelIds)) {
      let channelIds = compiledWidget[type].channelIds.split(',').filter(i => i.length > 0);
      if (channelIds.length === 0){
        channelIds = [];
      } else {
        channelIds.forEach((el, index) => {
          channelIds[index] = Number(el);
        });
      }

      compiledWidget[type].channelIds = channelIds;
    }
  } else {
    compiledWidget[type].channelIds = [];
  }

  // postprocess entity filtration
  if (compiledWidget[type].filterEntities) {
    if (!Array.isArray(compiledWidget[type].filterEntities)) {
      let filterEntities = compiledWidget[type].filterEntities.split(',').filter(i => i.length > 0);
      if (filterEntities.length === 0){
        filterEntities = [];
      } else {

        // todo: fix it from old code !!! (hotfix)
        filterEntities = filterEntities.map(x => {
          if (compiledWidget[type].grouping && compiledWidget[type].grouping === 'label') {

            // all labels MUST BE String
            return x.toString();
          }
          return numberOrText(x);
        });
      }

      compiledWidget[type].filterEntities = filterEntities;
    }
  } else {
    compiledWidget[type].filterEntities = [];
  }

  // postprocess project filtration
  if (compiledWidget[type].filteringProjects) {
    if (!Array.isArray(compiledWidget[type].filteringProjects)) {
      let filteringProjects = compiledWidget[type].filteringProjects.
        split(',').
        filter(i => i.length > 0).
        map(i => numberOrText(i));
      if (filteringProjects.length === 0) {
        filteringProjects = [];
      }

      compiledWidget[type].filteringProjects = filteringProjects;
    }
  } else if (compiledWidget[type]) {
    compiledWidget[type].filteringProjects = [];
  }

  // postprocess periods
  if (compiledWidget[type].periods) {
    if (typeof compiledWidget[type].periods !== 'object') {
      compiledWidget[type].periods = JSON.parse(compiledWidget[type].periods);
    }
  } else {
    compiledWidget[type].periods = null;
  }
  if (compiledWidget[type].customPeriod) {
    if (typeof compiledWidget[type].customPeriod !== 'object') {
      const customPeriod = JSON.parse(compiledWidget[type].customPeriod);
      compiledWidget[type].customPeriod = customPeriod;
    }
  } else {
    compiledWidget[type].customPeriod = null;
  }

  // postprocess plan-fact metrics
  if (compiledWidget[type].planFactMetrics) {
    if (!Array.isArray(compiledWidget[type].planFactMetrics)) {
      compiledWidget[type].planFactMetrics = JSON.
        parse(compiledWidget[type].planFactMetrics);
    }
  } else {
    compiledWidget[type].planFactMetrics = null;
  }

  return compiledWidget;
}
